export default __webpack_public_path__ + "static/media/language.1d2f01c6.mp4";